import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/black-arrow-right.svg")